import { createMutationHook } from '~/shared/providers/api';

export const useCreateFacilityGroupMutation = createMutationHook(
  'facilities.facilityGroupCreate',
  (params: { name: string; facilityIds?: string[] }) => ({
    coreFacilityGroupCreate: {
      __args: {
        input: {
          name: params.name,
          facilityIds: params.facilityIds,
        },
      },
      id: true,
      name: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
